import { isInternalUser } from './internal-user.utils';

/**
 * Whether an account can use the field notebook.
 * @remarks This is the internal-pilot gate. Opening the feature to customers
 * means changing only this function on each side; the processing hook must
 * keep selecting task users through this predicate.
 */
export function canUseFieldNotebook(email: string | null | undefined): boolean {
  return isInternalUser(email);
}
